module.exports = __webpack_public_path__ + "img/banner4_sound.16a8f3c6.jpg";